import {useState} from 'react'
import {PageHeader, SaveCancelFooter} from '@/components/molecules'
import {SalesTargetProducts} from '@/containers'
import {Breadcrumb, ProgressIndicator} from '@/components/atoms'
import {useAppDispatch} from '@/store'
import {useNavigate} from 'react-router-dom'
import {ROUTES} from '@/utils/constants/routesConstants'
import {setToastNotifications} from '@/store/slices/commonSlice'
import {resetSalesTarget} from '@/store/slices/salesTargetSlice'

const AddSalesTargetProduct = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [selectedType, setSelectedType] = useState('categoryProducts')
  const [formData, setFormData] = useState({})
  const [uploadComplete, setUploadComplete] = useState(false)

  const handleNextAction = () => {
    navigate(ROUTES.REVIEW)
  }

  const handleUpdate = () => {}

  const handleDraft = () => {
    dispatch(setToastNotifications({show: true, message: 'New Sales Target Drafted', type: 'info'}))
    navigate(ROUTES.SALES_TARGET_HOME)
  }
  const handleCancel = () => {
    dispatch(resetSalesTarget())
    navigate(ROUTES.SALES_TARGET_HOME)
  }

  return (
    <>
      <Breadcrumb
        uiSchema={{
          isDark: true,
          className: 'mb-5',
          breadcrumbs: [
            {
              href: '/',
              label: '',
            },

            {
              href: '',
              label: 'Add Sales Target Mexico',
            },
          ],
        }}
        id={'astp_bradcrumb'}
      />

      <PageHeader title={'Add Sales Target'} />

      <div className="mb-6">
        <ProgressIndicator
          currentStep={3}
          isDark={true}
          completed={false}
          steps={4}
          titles={[{title: 'Setup'}, {title: 'Display Content'}, {title: 'Products'}, {title: 'Review'}]}
          className="mb-6"
        />
      </div>
      <br />
      <SalesTargetProducts
        selectedType={selectedType}
        setSelectedType={setSelectedType}
        uploadComplete={uploadComplete}
        setUploadComplete={setUploadComplete}
        onUpdate={handleUpdate}
        formData={formData}
        setFormData={setFormData}
      />
      <SaveCancelFooter
        FormError={false}
        handleCancel={handleCancel}
        draftAction={handleDraft}
        nextAction={handleNextAction}
      />
    </>
  )
}

export default AddSalesTargetProduct
